module.exports = __webpack_public_path__ + "img/coach.99d10f8e.svg";